import Axios from 'axios';

import { ADMIN_API_URL, API_URL, PIGGY_BACKR_API_BASE_URL } from 'constants/api-paths';

const AxiosClient = Axios.create({
  baseURL: API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Key-Inflection': 'camel',
  },
  withCredentials: true,
});

export const piggyBackrAxiosClient = Axios.create({
  baseURL: PIGGY_BACKR_API_BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Key-Inflection': 'camel',
  },
});

export const AdminApiClient = Axios.create({
  baseURL: ADMIN_API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Key-Inflection': 'camel',
  },
  withCredentials: true,
});

export default AxiosClient;
